//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/nl.json'));

export default {
  name: 'Praktijkgegevens',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    inBuitenland: false,
  }),
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    countries() {
      const list = countries.getNames('nl', {select: 'official'});
      return Object.keys(list).map(key => ({value: key, label: list[key]}));
    },
  },
  methods: {
    getAddress() {
      if (!this.inBuitenland) {
        this.$emit('getAddress');
      }
    },
  },
};
